import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { getDataHoraFormatada } from '../utils/dataUtils';
import { sortData } from '../common/table/sortHelper';
import Form from './aplicacaoForm';
import Select from '../common/form/select';

import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista,
    getOpcoes,
    getAreas
} from './aplicacaoActions';

const agora = () => {
    const data = new Date();
    data.setMinutes(
        data.getMinutes() - data.getTimezoneOffset()
    );
    return data.toISOString().substring(0, 16);
};

const moeda = valor =>
    `R$ ${FormatUtils.formatarValorTela(valor || 0, 2)}`;

const dataLocal = valor => {
    const data = new Date(valor);

    if (Number.isNaN(data.getTime())) {
        return '';
    }

    data.setMinutes(
        data.getMinutes() - data.getTimezoneOffset()
    );

    return data.toISOString().substring(0, 10);
};

const formatarDataInput = valor => {
    const data = new Date(valor);

    data.setMinutes(
        data.getMinutes() - data.getTimezoneOffset()
    );

    return data.toISOString().substring(0, 10);
};

const criarPeriodoPadrao = () => {
    const dataFinal = new Date();
    const dataInicial = new Date();

    dataInicial.setDate(dataInicial.getDate() - 31);

    return {
        dataInicial: formatarDataInput(dataInicial),
        dataFinal: formatarDataInput(dataFinal)
    };
};

const FiltrosAplicacao = props => (
    <div
        style={{
            marginTop: 8,
            padding: '12px 12px 2px',
            borderRadius: 10,
            background: '#f3f7fb',
            border: '1px solid #dce3eb'
        }}
    >
        <Row>
            <Grid cols='12 6 3 2'>
                <div className='form-group'>
                    <label>Data inicial</label>
                    <input
                        type='date'
                        className='form-control'
                        value={props.dataInicial}
                        onChange={event =>
                            props.onDataInicial(
                                event.target.value
                            )}
                    />
                </div>
            </Grid>
            <Grid cols='12 6 3 2'>
                <div className='form-group'>
                    <label>Data final</label>
                    <input
                        type='date'
                        className='form-control'
                        value={props.dataFinal}
                        onChange={event =>
                            props.onDataFinal(
                                event.target.value
                            )}
                    />
                </div>
            </Grid>
            <Select
                name='filtro_clientes_aplicacao'
                options={props.clientes}
                label='Cliente'
                cols='12 12 6 3'
                multiple
                value={props.idsClientes}
                onChange={itens =>
                    props.onClientes(
                        (itens || []).map(item =>
                            Number(item.value)
                        )
                    )}
            />
            <Select
                name='filtro_status_aplicacao'
                options={props.status}
                label='Status'
                cols='12 12 6 3'
                multiple
                value={props.idsStatus}
                onChange={itens =>
                    props.onStatus(
                        (itens || []).map(item =>
                            Number(item.value)
                        )
                    )}
            />
            <Grid cols='12 6 3 2'>
                <button
                    type='button'
                    className='btn btn-light'
                    onClick={props.onLimpar}
                    style={{
                        width: '100%',
                        minHeight: 38,
                        marginTop: 29,
                        border: '1px solid #cbd5e1',
                        borderRadius: 8
                    }}
                >
                    <i
                        className='fas fa-eraser'
                        style={{ marginRight: 7 }}
                    />
                    Limpar filtros
                </button>
            </Grid>
        </Row>
    </div>
);

const colunas = [
    { field: 'numero', type: 'number' },
    { field: 'datahora_solicitacao', type: 'date' },
    { field: 'nome_cliente', type: 'text' },
    { field: 'nome_aplicador', type: 'text' },
    { field: 'nome_tipo', type: 'text' },
    { field: 'nome_status', type: 'text' },
    { field: 'valor_final', type: 'number' }
];

const Aplicacao = props => {
    const [pesquisa, setPesquisa] = useState('');
    const [linhaSelecionada, setLinhaSelecionada] =
        useState(null);
    const [filtros, setFiltros] = useState({
        ...criarPeriodoPadrao(),
        idsClientes: [],
        idsStatus: []
    });
    const [sort, setSort] = useState({
        field: 'numero',
        direction: 'desc'
    });

    useEffect(() => {
        props.getLista();
        props.getOpcoes();
    }, []);

    const abrir = (modo, item) => {
        props.setModoTela(modo, item);
        props.initForm(item);
        props.getAreas(item.id_cliente);
    };

    const listaFiltrada = (props.lista || []).filter(item => {
        const termo = pesquisa.trim().toUpperCase();

        const dataItem = dataLocal(
            item.datahora_solicitacao
        );

        if (
            filtros.dataInicial &&
            dataItem < filtros.dataInicial
        ) {
            return false;
        }

        if (
            filtros.dataFinal &&
            dataItem > filtros.dataFinal
        ) {
            return false;
        }

        if (
            filtros.idsClientes.length &&
            !filtros.idsClientes.includes(
                Number(item.id_cliente)
            )
        ) {
            return false;
        }

        if (
            filtros.idsStatus.length &&
            !filtros.idsStatus.includes(
                Number(item.id_status)
            )
        ) {
            return false;
        }

        if (!termo) {
            return true;
        }
        return [
            item.numero,
            item.nome_cliente,
            item.nome_aplicador,
            item.email_aplicador,
            item.celular_aplicador,
            item.nome_status,
            item.nome_tipo,
            item.nomes_veiculos
        ].join(' ').toUpperCase().includes(termo);
    });
    const lista = sortData(listaFiltrada, sort, colunas);
    const onSort = field => {
        setSort(anterior => ({
            field,
            direction:
                anterior.field === field &&
                anterior.direction === 'asc'
                    ? 'desc'
                    : 'asc'
        }));
    };
    const alturaTabela = Math.max(
        250,
        window.innerWidth < 631
            ? window.innerHeight - 430
            : window.innerHeight - 320
    );
    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ExcelFile.ExcelSheet;
    const ExcelColumn = ExcelFile.ExcelColumn;

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />

            {props.modoTela === 'cadastro' &&
                <Form onSubmit={props.salvar} />}

            {props.modoTela === 'exclusao' &&
                <Form excluir onSubmit={props.excluir} />}

            {props.modoTela === 'lista' &&
                <ContentCard>
                    <ContentCardHeader>
                        <Row>
                            <InputPesquisa
                                cols='12 6 3 1'
                                label='Pesquisar'
                                minWidth={344}
                                onChange={setPesquisa}
                            />
                            <div>
                                <button
                                    type='button'
                                    className='btn btn-app bg-success'
                                    style={{
                                        marginLeft: 2,
                                        minWidth: 75
                                    }}
                                    onClick={() => {
                                        props.setModoTela(
                                            'cadastro',
                                            {}
                                        );
                                        props.initForm({
                                            datahora_solicitacao:
                                                agora(),
                                            status: 'PEDIDO',
                                            ids_veiculos: [],
                                            data_primeiro_vencimento:
                                                agora().substring(0, 10),
                                            quantidade_parcelas: 1,
                                            id_plano_conta_receita: 2,
                                            id_forma_pagamento: null,
                                            nome_aplicador: '',
                                            email_aplicador: '',
                                            celular_aplicador: '',
                                            prescricoes: [],
                                            observacao: ''
                                        });
                                        props.getAreas(null);
                                    }}
                                >
                                    <i className='fas fa-plus' />
                                    Adicionar
                                </button>
                                <button
                                    type='button'
                                    className='btn btn-app bg-primary'
                                    style={{
                                        marginLeft: 2,
                                        minWidth: 75
                                    }}
                                    onClick={() => {
                                        props.getLista();
                                        props.getOpcoes();
                                    }}
                                >
                                    <i className='fas fa-sync-alt' />
                                    Atualizar
                                </button>
                                <ExcelFile
                                    filename='Aplicacoes'
                                    element={
                                        <button
                                            type='button'
                                            className='btn btn-app bg-info'
                                            style={{
                                                marginLeft: 2,
                                                minWidth: 75
                                            }}
                                        >
                                            <i className='fas fa-file-excel' />
                                            Exportar
                                        </button>
                                    }
                                >
                                    <ExcelSheet
                                        name='Aplicações'
                                        data={lista.map(item => ({
                                            ...item,
                                            data_formatada:
                                                getDataHoraFormatada(
                                                    item.datahora_solicitacao,
                                                    'DD/MM/YYYY HH:mm'
                                                ),
                                            valor_final_formatado:
                                                moeda(item.valor_final)
                                        }))}
                                    >
                                        <ExcelColumn
                                            label='Número'
                                            value='numero'
                                        />
                                        <ExcelColumn
                                            label='Data da Solicitação'
                                            value='data_formatada'
                                        />
                                        <ExcelColumn
                                            label='Cliente'
                                            value='nome_cliente'
                                        />
                                        <ExcelColumn
                                            label='Aplicador'
                                            value='nome_aplicador'
                                        />
                                        <ExcelColumn
                                            label='E-mail do aplicador'
                                            value='email_aplicador'
                                        />
                                        <ExcelColumn
                                            label='Telefone do aplicador'
                                            value='celular_aplicador'
                                        />
                                        <ExcelColumn
                                            label='Tipo'
                                            value='nome_tipo'
                                        />
                                        <ExcelColumn
                                            label='Status'
                                            value='nome_status'
                                        />
                                        <ExcelColumn
                                            label='Veículos'
                                            value='nomes_veiculos'
                                        />
                                        <ExcelColumn
                                            label='Total Geral'
                                            value='valor_final_formatado'
                                        />
                                    </ExcelSheet>
                                </ExcelFile>
                            </div>
                        </Row>
                        <FiltrosAplicacao
                            dataInicial={filtros.dataInicial}
                            dataFinal={filtros.dataFinal}
                            idsClientes={filtros.idsClientes}
                            idsStatus={filtros.idsStatus}
                            clientes={props.clientes}
                            status={props.status}
                            onDataInicial={valor =>
                                setFiltros({
                                    ...filtros,
                                    dataInicial: valor
                                })}
                            onDataFinal={valor =>
                                setFiltros({
                                    ...filtros,
                                    dataFinal: valor
                                })}
                            onClientes={valores =>
                                setFiltros({
                                    ...filtros,
                                    idsClientes: valores
                                })}
                            onStatus={valores =>
                                setFiltros({
                                    ...filtros,
                                    idsStatus: valores
                                })}
                            onLimpar={() => setFiltros({
                                ...criarPeriodoPadrao(),
                                idsClientes: [],
                                idsStatus: []
                            })}
                        />
                    </ContentCardHeader>

                    <ContentCardBody>
                        <Table
                            responsive
                            border
                            alturaFixa
                            striped
                            maxHeight={alturaTabela}
                        >
                            <THead>
                                <Tr>
                                    <ThSort
                                        field='numero'
                                        label='Número'
                                        width={90}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='datahora_solicitacao'
                                        label='Data da Solicitação'
                                        width={150}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='nome_cliente'
                                        label='Cliente'
                                        width={240}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='nome_aplicador'
                                        label='Aplicador'
                                        width={180}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='nome_tipo'
                                        label='Tipo'
                                        width={110}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='nome_status'
                                        label='Status'
                                        width={170}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <Th width={200}>Veículos</Th>
                                    <ThSort
                                        field='valor_final'
                                        label='Total Geral'
                                        width={130}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <Th sticky alignCenter width={100} />
                                </Tr>
                            </THead>
                            <TBody>
                                {lista.map((item, index) => (
                                    <Tr
                                        key={item.id}
                                        backgroundColor={
                                            linhaSelecionada === item.id
                                                ? '#bcc7eb'
                                                : index % 2 === 0
                                                    ? '#ffffff'
                                                    : '#f5f5f5'
                                        }
                                    >
                                        <Td
                                            alignCenter
                                            onClick={() =>
                                                setLinhaSelecionada(
                                                    item.id
                                                )}
                                        >
                                            {item.numero}
                                        </Td>
                                        <Td
                                            alignCenter
                                            onClick={() =>
                                                setLinhaSelecionada(
                                                    item.id
                                                )}
                                        >
                                            {getDataHoraFormatada(
                                                item.datahora_solicitacao,
                                                'DD/MM/YYYY HH:mm'
                                            )}
                                        </Td>
                                        <Td
                                            alignCenter
                                            onClick={() =>
                                                setLinhaSelecionada(
                                                    item.id
                                                )}
                                        >
                                            {item.nome_cliente}
                                        </Td>
                                        <Td
                                            alignCenter
                                            onClick={() =>
                                                setLinhaSelecionada(
                                                    item.id
                                                )}
                                        >
                                            {item.nome_aplicador}
                                        </Td>
                                        <Td
                                            alignCenter
                                            onClick={() =>
                                                setLinhaSelecionada(
                                                    item.id
                                                )}
                                        >
                                            {item.nome_tipo}
                                        </Td>
                                        <Td
                                            alignCenter
                                            onClick={() =>
                                                setLinhaSelecionada(
                                                    item.id
                                                )}
                                        >
                                            {item.nome_status}
                                        </Td>
                                        <Td
                                            alignCenter
                                            onClick={() =>
                                                setLinhaSelecionada(
                                                    item.id
                                                )}
                                        >
                                            {item.nomes_veiculos}
                                        </Td>
                                        <Td
                                            alignCenter
                                            onClick={() =>
                                                setLinhaSelecionada(
                                                    item.id
                                                )}
                                        >
                                            {moeda(item.valor_final)}
                                        </Td>
                                        <Td alignCenter>
                                            <ButtonTable
                                                type='info'
                                                width={32}
                                                small
                                                icon='fas fa-eye'
                                                visible
                                                title='Abrir'
                                                event={() =>
                                                    abrir(
                                                        'cadastro',
                                                        item
                                                    )}
                                            />
                                            <ButtonTable
                                                type='danger'
                                                width={32}
                                                small
                                                icon='fas fa-trash-alt'
                                                visible={
                                                    item.status ===
                                                    'PEDIDO'
                                                }
                                                title='Excluir'
                                                event={() =>
                                                    abrir(
                                                        'exclusao',
                                                        item
                                                    )}
                                            />
                                        </Td>
                                    </Tr>
                                ))}
                            </TBody>
                        </Table>
                    </ContentCardBody>
                </ContentCard>}
        </Content>
    );
};

const mapStateToProps = state => ({
    modoTela: state.aplicacao.modoTela,
    aguardando: state.aplicacao.aguardando,
    lista: state.aplicacao.lista,
    clientes: state.aplicacao.clientes.map(item => ({
        ...item,
        valor: item.razao_social
    })),
    status: state.aplicacao.status.map(item => ({
        ...item,
        valor: item.descricao
    }))
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        setModoTela,
        initForm,
        salvar,
        excluir,
        getLista,
        getOpcoes,
        getAreas
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Aplicacao);
